"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTypeHierarchy = exports.DataType = void 0;
const type_1 = __importDefault(require("hcore/dist/type"));
var DataType;
(function (DataType) {
    DataType["varchar"] = "varchar";
    DataType["int"] = "int";
    DataType["float"] = "float";
    DataType["boolean"] = "boolean";
    DataType["date"] = "date";
    DataType["time"] = "time";
    DataType["datetime"] = "timestamp";
})(DataType = exports.DataType || (exports.DataType = {}));
exports.DataTypeHierarchy = {
    'varchar': ['int', 'float', 'boolean', 'date', 'datetime', 'time'],
    'int': ['boolean'],
    'float': ['int'],
    'boolean': ['int'],
    'date': [],
    'time': [],
    'timestamp': ['date', 'time'],
};
class DataCell {
    constructor(rawValue) {
        this.rawValue = rawValue;
        this.type = DataType.varchar;
        if (this.rawValue.trim() === '') {
            this.isNull = true;
            return;
        }
        if (type_1.default.isSqlDatetime(this.rawValue)) {
            this.type = DataType.datetime;
        }
        else if (type_1.default.isSqlDate(this.rawValue)) {
            this.type = DataType.date;
        }
        else if (type_1.default.isSqlTime(this.rawValue)) {
            this.type = DataType.time;
        }
        else if (type_1.default.isDatetime(this.rawValue)) {
            this.type = DataType.datetime;
        }
        else if (type_1.default.isDate(this.rawValue)) {
            this.type = DataType.date;
        }
        else if (type_1.default.isTime(this.rawValue)) {
            this.type = DataType.time;
        }
        else if (type_1.default.isInt(this.rawValue)) {
            this.type = DataType.int;
        }
        else if (type_1.default.isFloat(this.rawValue)) {
            this.type = DataType.float;
        }
        else if (type_1.default.isBoolean(this.rawValue)) {
            this.type = DataType.boolean;
        }
    }
    get sqlDatetime() {
        if (this.type !== DataType.datetime) {
            throw new Error("Must be SQL Datetime");
        }
        const date = new Date(this.rawValue);
        return date.toISOString().slice(0, 19).replace('T', ' ');
    }
}
exports.default = DataCell;
